import { useState, useEffect, useCallback } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import PageHeader from '../../components/PageHeader';
import ToastNotification from '../../components/ToastNotification';
import styles from './RegistrationPage.module.css';

function RoleBadge({ role }) {
  const label = role ? role.charAt(0).toUpperCase() + role.slice(1) : role;
  const cls = role === 'admin' ? styles.roleAdmin
    : role === 'supplier' ? styles.roleSupplier
    : styles.roleBranch;
  return <span className={`${styles.roleBadge} ${cls}`}>{label}</span>;
}

function StatusBadge({ status }) {
  return (
    <span className={`${styles.statusBadge} ${status === 'Active' ? styles.statusActive : styles.statusInactive}`}>
      {status}
    </span>
  );
}

function formatDate(ts) {
  if (!ts) return '—';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toISOString().slice(0, 10);
}

export default function RegistrationPage() {
  const [accounts, setAccounts] = useState([]);
  const [toast, setToast]       = useState(null);
  const dismissToast             = useCallback(() => setToast(null), []);

  useEffect(() => {
    const q = query(collection(db, 'users'), where('status', 'in', ['Active', 'Inactive']));
    return onSnapshot(q, snap => {
      setAccounts(snap.docs.map(d => ({ _docId: d.id, ...d.data() })));
    });
  }, []);

  return (
    <div className={styles.page}>
      <PageHeader
        title="Registration & Verification"
        description="All accounts are created and managed directly by the admin."
      />

      <div className={styles.notice}>
        <span className={styles.noticeIcon}>ℹ</span>
        Accounts are created by the admin and activated immediately. Use Maintenance → Users to add or deactivate accounts.
      </div>

      <div className={styles.tabContent}>
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>User ID</th>
                <th>Full Name</th>
                <th>Role</th>
                <th>Branch / Company</th>
                <th>Created</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {accounts.length === 0 ? (
                <tr><td colSpan={6} className={styles.empty}>No accounts found.</td></tr>
              ) : (
                accounts.map((u, i) => (
                  <tr key={u._docId} className={i % 2 === 0 ? styles.rowEven : styles.rowOdd}>
                    <td className={styles.recordId}>{u._docId.slice(0, 8)}</td>
                    <td className={styles.name}>{u.name}</td>
                    <td><RoleBadge role={u.role} /></td>
                    <td>{u.entity}</td>
                    <td>{formatDate(u.createdAt)}</td>
                    <td><StatusBadge status={u.status} /></td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {toast && (
        <ToastNotification message={toast.message} type={toast.type} onDismiss={dismissToast} />
      )}
    </div>
  );
}
